export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  updateDate: string;
  pageCount: number;
}

export interface ComicReview {
  id: number;
  username: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  likes: number;
}

export interface Comic {
  id: number;
  title: string;
  slug: string;
  cover: string;
  author: string;
  category: string;
  categories: string[];
  status: '连载中' | '已完结';
  description: string;
  shortDescription: string;
  rating: number;
  ratingCount: number;
  views: number;
  favorites: number;
  updateDate: string;
  latestChapter: string;
  chapters: ComicChapter[];
  reviews: ComicReview[];
  tags: string[];
  featured: boolean;
  isHot: boolean;
}

export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览全部漫画作品', count: 1280 },
  { slug: 'shounen', name: '少年热血', icon: 'ri-fire-line', description: '热血少年冒险战斗漫画', count: 320 },
  { slug: 'romance', name: '恋爱校园', icon: 'ri-heart-line', description: '甜蜜浪漫校园恋爱故事', count: 280 },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', description: '奇幻世界冒险探索之旅', count: 256 },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松搞笑日常欢乐漫画', count: 210 },
  { slug: 'suspense', name: '悬疑推理', icon: 'ri-search-eye-line', description: '烧脑悬疑推理探案经典', count: 145 },
  { slug: 'action', name: '动作格斗', icon: 'ri-boxing-line', description: '激烈动作格斗对决场面', count: 168 },
  { slug: 'scifi', name: '科幻未来', icon: 'ri-rocket-line', description: '未来科幻宇宙探索故事', count: 132 },
  { slug: 'horror', name: '恐怖惊悚', icon: 'ri-ghost-line', description: '惊悚恐怖悬疑心理漫画', count: 98 },
  { slug: 'slice-of-life', name: '治愈日常', icon: 'ri-cup-line', description: '温暖治愈日常生活点滴', count: 185 },
  { slug: 'historical', name: '历史古风', icon: 'ri-ancient-gate-line', description: '古风历史权谋宫廷故事', count: 76 },
  { slug: 'sports', name: '运动竞技', icon: 'ri-basketball-line', description: '热血运动竞技拼搏精神', count: 89 },
];

export const allComics: Comic[] = [
  {
    id: 1,
    title: '星海征途',
    slug: 'star-ocean-journey',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20cover%20illustration%20of%20a%20young%20male%20hero%20with%20determined%20expression%20standing%20on%20a%20spaceship%20deck%2C%20stars%20and%20galaxies%20in%20background%2C%20dynamic%20pose%2C%20vibrant%20warm%20orange%20and%20gold%20color%20palette%2C%20Japanese%20manga%20art%20style%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    author: '星河老师',
    category: 'scifi',
    categories: ['scifi', 'action', 'fantasy'],
    status: '连载中',
    description: '在遥远的未来，人类已经遍布银河系的各个角落。年轻的太空探险家林星河在一次意外中发现了一个古老的星际遗迹，由此展开了一段惊心动魄的宇宙冒险之旅。从神秘的外星文明到浩瀚的星辰大海，他将面对前所未有的挑战与机遇。',
    shortDescription: '年轻太空探险家在星际间展开惊心动魄的宇宙冒险',
    rating: 9.6,
    ratingCount: 18520,
    views: 12563000,
    favorites: 892500,
    updateDate: '2026-08-03',
    latestChapter: '第238话 星辰之门',
    tags: ['科幻', '冒险', '太空', '热血', '机甲'],
    featured: true,
    isHot: true,
    chapters: [
      { id: 238, title: '第238话 星辰之门', number: 238, updateDate: '2026-08-03', pageCount: 48 },
      { id: 237, title: '第237话 遗迹深处', number: 237, updateDate: '2026-07-27', pageCount: 52 },
      { id: 236, title: '第236话 古老的信号', number: 236, updateDate: '2026-07-20', pageCount: 45 },
      { id: 235, title: '第235话 穿越风暴', number: 235, updateDate: '2026-07-13', pageCount: 50 },
      { id: 234, title: '第234话 新伙伴', number: 234, updateDate: '2026-07-06', pageCount: 46 },
      { id: 233, title: '第233话 黑暗中的光芒', number: 233, updateDate: '2026-06-29', pageCount: 44 },
      { id: 232, title: '第232话 绝境求生', number: 232, updateDate: '2026-06-22', pageCount: 49 },
      { id: 231, title: '第231话 星图之谜', number: 231, updateDate: '2026-06-15', pageCount: 47 },
      { id: 230, title: '第230话 联盟危机', number: 230, updateDate: '2026-06-08', pageCount: 51 },
      { id: 229, title: '第229话 秘密任务', number: 229, updateDate: '2026-06-01', pageCount: 43 },
    ],
    reviews: [
      { id: 1, username: '星际漫游者', avatar: '', rating: 5, content: '这部漫画的世界观太宏大了！每次更新都让人迫不及待想看到下一话，林星河的成长线写得非常扎实。', date: '2026-08-02', likes: 1256 },
      { id: 2, username: '漫画迷小王', avatar: '', rating: 5, content: '画风精致，剧情紧凑，科幻设定有理有据，是目前国产科幻漫画的顶尖作品！', date: '2026-08-01', likes: 892 },
      { id: 3, username: '夜空中的星', avatar: '', rating: 4, content: '节奏把控很好，伏笔也埋得巧妙，就是更新稍微有点慢，每周都在等。', date: '2026-07-30', likes: 567 },
    ],
  },
  {
    id: 2,
    title: '樱花下的约定',
    slug: 'cherry-blossom-promise',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20manga%20style%20cover%20illustration%20of%20a%20young%20couple%20under%20cherry%20blossom%20trees%2C%20school%20uniforms%2C%20gentle%20pink%20petals%20falling%2C%20warm%20spring%20sunlight%2C%20soft%20pastel%20color%20palette%2C%20beautiful%20Japanese%20shoujo%20manga%20art%20style%2C%20dreamy%20atmosphere&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    author: '落樱绘梦',
    category: 'romance',
    categories: ['romance', 'slice-of-life'],
    status: '连载中',
    description: '高中二年级的苏小樱在樱花盛开的季节遇到了转学生林晨。两人的相遇看似偶然，却似乎是命运的安排。在樱花树下，他们许下了彼此的约定。然而，成长的路上总有各种考验，青春的故事在樱花飞舞中缓缓展开。',
    shortDescription: '樱花树下青春校园恋爱故事，甜蜜又感动',
    rating: 9.4,
    ratingCount: 22300,
    views: 15680000,
    favorites: 1023000,
    updateDate: '2026-08-04',
    latestChapter: '第156话 不变的约定',
    tags: ['校园', '恋爱', '青春', '治愈', '成长'],
    featured: true,
    isHot: true,
    chapters: [
      { id: 156, title: '第156话 不变的约定', number: 156, updateDate: '2026-08-04', pageCount: 42 },
      { id: 155, title: '第155话 雨中的告白', number: 155, updateDate: '2026-07-28', pageCount: 45 },
      { id: 154, title: '第154话 误会', number: 154, updateDate: '2026-07-21', pageCount: 40 },
      { id: 153, title: '第153话 心跳加速', number: 153, updateDate: '2026-07-14', pageCount: 43 },
      { id: 152, title: '第152话 夏日祭典', number: 152, updateDate: '2026-07-07', pageCount: 48 },
    ],
    reviews: [
      { id: 1, username: '樱花少女', avatar: '', rating: 5, content: '每次看都让人少女心爆棚！苏小樱和林晨的感情线太甜了，画风也超级精美。', date: '2026-08-03', likes: 2340 },
      { id: 2, username: '只爱看恋爱漫', avatar: '', rating: 5, content: '国产恋爱漫画的巅峰之作，剧情不狗血，人物塑造饱满，强烈推荐！', date: '2026-08-02', likes: 1876 },
      { id: 3, username: '晨光微曦', avatar: '', rating: 4, content: '青春的味道扑面而来，让我想起了自己的高中时光，非常治愈。', date: '2026-07-31', likes: 934 },
    ],
  },
  {
    id: 3,
    title: '斗神无双',
    slug: 'invincible-fighter',
    cover: 'https://readdy.ai/api/search-image?query=A%20fierce%20manga%20style%20cover%20of%20a%20martial%20arts%20fighter%20with%20flaming%20fists%20in%20battle%20stance%2C%20dramatic%20lighting%2C%20energy%20aura%20surrounding%20the%20character%2C%20intense%20expression%2C%20dynamic%20action%20pose%2C%20bold%20red%20and%20dark%20color%20scheme%2C%20professional%20shounen%20manga%20art%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    author: '铁拳无双',
    category: 'action',
    categories: ['action', 'shounen', 'fantasy'],
    status: '连载中',
    description: '在一个以武为尊的世界里，少年秦天从小被师父收养，习得一身绝世武功。为了寻找失踪的师父，他踏上了充满挑战的冒险之路。在这个强者为尊的世界中，他将用双拳打出属于自己的传奇！',
    shortDescription: '热血少年用双拳在武斗世界打出传奇之路',
    rating: 9.3,
    ratingCount: 19800,
    views: 14250000,
    favorites: 956000,
    updateDate: '2026-08-04',
    latestChapter: '第312话 终极对决',
    tags: ['格斗', '热血', '冒险', '成长', '少年'],
    featured: false,
    isHot: true,
    chapters: [
      { id: 312, title: '第312话 终极对决', number: 312, updateDate: '2026-08-04', pageCount: 55 },
      { id: 311, title: '第311话 突破极限', number: 311, updateDate: '2026-07-28', pageCount: 50 },
      { id: 310, title: '第310话 宿命的对决', number: 310, updateDate: '2026-07-21', pageCount: 52 },
      { id: 309, title: '第309话 暗影来袭', number: 309, updateDate: '2026-07-14', pageCount: 48 },
      { id: 308, title: '第308话 新的力量', number: 308, updateDate: '2026-07-07', pageCount: 45 },
    ],
    reviews: [
      { id: 1, username: '格斗之魂', avatar: '', rating: 5, content: '打斗场面太燃了！每一场战斗都让人热血沸腾，秦天的人物成长线也很棒。', date: '2026-08-03', likes: 1567 },
      { id: 2, username: '热血少年', avatar: '', rating: 5, content: '这才是真正的热血格斗漫画！招式设计新颖，剧情跌宕起伏，满分推荐！', date: '2026-08-02', likes: 1234 },
    ],
  },
  {
    id: 4,
    title: '魔法学院物语',
    slug: 'magic-academy-tales',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20fantasy%20manga%20cover%20illustration%20of%20young%20wizards%20in%20a%20magic%20academy%2C%20floating%20spell%20books%20and%20magical%20creatures%2C%20castle%20interior%20background%2C%20warm%20magical%20glow%20effects%2C%20colorful%20spell%20effects%2C%20fantasy%20adventure%20theme%2C%20beautiful%20detailed%20manga%20art%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    author: '魔法绘师',
    category: 'fantasy',
    categories: ['fantasy', 'comedy', 'slice-of-life'],
    status: '连载中',
    description: '普通高中生白晓月意外收到了一封魔法学院的录取通知书。在这个充满魔法与奇迹的世界里，她将认识各种神奇的朋友，学习令人惊叹的魔法，并揭开隐藏在学院深处的千年秘密。',
    shortDescription: '魔法学院里的奇幻冒险与成长故事',
    rating: 9.5,
    ratingCount: 16800,
    views: 11230000,
    favorites: 789000,
    updateDate: '2026-08-03',
    latestChapter: '第189话 千年之谜',
    tags: ['魔法', '学院', '冒险', '奇幻', '搞笑'],
    featured: true,
    isHot: true,
    chapters: [
      { id: 189, title: '第189话 千年之谜', number: 189, updateDate: '2026-08-03', pageCount: 44 },
      { id: 188, title: '第188话 隐藏的真相', number: 188, updateDate: '2026-07-27', pageCount: 46 },
      { id: 187, title: '第187话 禁书区', number: 187, updateDate: '2026-07-20', pageCount: 42 },
      { id: 186, title: '第186话 教授的过去', number: 186, updateDate: '2026-07-13', pageCount: 45 },
      { id: 185, title: '第185话 龙之试炼', number: 185, updateDate: '2026-07-06', pageCount: 50 },
    ],
    reviews: [
      { id: 1, username: '魔法少女', avatar: '', rating: 5, content: '魔法世界的设定非常有趣！每个角色都有独特的魅力，剧情轻松又引人入胜。', date: '2026-08-02', likes: 987 },
      { id: 2, username: '奇幻迷', avatar: '', rating: 5, content: '画风精美，魔法效果华丽，故事温暖治愈，每周追更中！', date: '2026-08-01', likes: 765 },
    ],
  },
  {
    id: 5,
    title: '推理之眼',
    slug: 'eye-of-deduction',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20detective%20manga%20cover%20with%20a%20sharp%20eyed%20detective%20character%20in%20dark%20coat%2C%20magnifying%20glass%2C%20shadowy%20mysterious%20background%20with%20clues%20and%20evidence%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20suspenseful%20tone%2C%20professional%20seinen%20manga%20art%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    author: '暗夜推理',
    category: 'suspense',
    categories: ['suspense', 'action'],
    status: '已完结',
    description: '天才高中生侦探韩夜拥有超凡的观察力和推理能力。每当案件发生，他总能从最细微的线索中找到真相。从校园谜案到城市连环案件，他用推理之眼揭开一个又一个令人震惊的真相。',
    shortDescription: '天才高中生侦探用超凡推理破解离奇案件',
    rating: 9.7,
    ratingCount: 31200,
    views: 18960000,
    favorites: 1235000,
    updateDate: '2026-06-15',
    latestChapter: '第245话 真相大白（完结）',
    tags: ['推理', '悬疑', '侦探', '校园', '烧脑'],
    featured: true,
    isHot: false,
    chapters: [
      { id: 245, title: '第245话 真相大白（完结）', number: 245, updateDate: '2026-06-15', pageCount: 60 },
      { id: 244, title: '第244话 最后的线索', number: 244, updateDate: '2026-06-08', pageCount: 48 },
      { id: 243, title: '第243话 逆转', number: 243, updateDate: '2026-06-01', pageCount: 52 },
      { id: 242, title: '第242话 隐藏的证据', number: 242, updateDate: '2026-05-25', pageCount: 45 },
      { id: 241, title: '第241话 新的嫌疑人', number: 241, updateDate: '2026-05-18', pageCount: 47 },
    ],
    reviews: [
      { id: 1, username: '推理爱好者', avatar: '', rating: 5, content: '完结撒花！这是我近几年看过最精彩的推理漫画，每个案件都环环相扣，逻辑严密。', date: '2026-07-20', likes: 3456 },
      { id: 2, username: '悬疑控', avatar: '', rating: 5, content: '从第一话追到完结，每一话都不舍得跳过。韩夜的推理过程真的太精彩了！', date: '2026-07-15', likes: 2789 },
      { id: 3, username: '名侦探小陈', avatar: '', rating: 5, content: '国产推理漫画的里程碑之作，希望能够有第二部！', date: '2026-07-10', likes: 2100 },
    ],
  },
  {
    id: 6,
    title: '搞笑三人行',
    slug: 'funny-trio',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20manga%20cover%20with%20three%20exaggerated%20funny%20facial%20expression%20characters%2C%20chibi%20style%2C%20bright%20colorful%20school%20setting%2C%20comical%20poses%2C%20humorous%20vibe%2C%20light%20hearted%20atmosphere%2C%20cute%20and%20funny%20Japanese%20gag%20manga%20art%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    author: '笑匠工坊',
    category: 'comedy',
    categories: ['comedy', 'slice-of-life'],
    status: '连载中',
    description: '三个性格迥异的高中生——天然呆的小胖、腹黑的眼镜男和热血笨蛋，每天上演着令人捧腹的校园日常。他们的搞笑生活让你笑到停不下来，忘记一切烦恼！',
    shortDescription: '三个活宝高中生的爆笑校园日常故事',
    rating: 9.2,
    ratingCount: 14200,
    views: 10890000,
    favorites: 678000,
    updateDate: '2026-08-03',
    latestChapter: '第201话 考试大作战',
    tags: ['搞笑', '校园', '日常', '轻松', '治愈'],
    featured: false,
    isHot: true,
    chapters: [
      { id: 201, title: '第201话 考试大作战', number: 201, updateDate: '2026-08-03', pageCount: 38 },
      { id: 200, title: '第200话 两百话纪念', number: 200, updateDate: '2026-07-27', pageCount: 45 },
      { id: 199, title: '第199话 校园祭筹备', number: 199, updateDate: '2026-07-20', pageCount: 40 },
      { id: 198, title: '第198话 班主任的秘密', number: 198, updateDate: '2026-07-13', pageCount: 42 },
      { id: 197, title: '第197话 体育课的灾难', number: 197, updateDate: '2026-07-06', pageCount: 38 },
    ],
    reviews: [
      { id: 1, username: '哈哈笑不停', avatar: '', rating: 5, content: '每次心情不好的时候就来追更新，真的是解压神器！三个人太有梗了。', date: '2026-08-02', likes: 1023 },
      { id: 2, username: '快乐每一天', avatar: '', rating: 5, content: '国产搞笑漫画的天花板！每话都能让我笑出声来，强烈推荐。', date: '2026-08-01', likes: 876 },
    ],
  },
  {
    id: 7,
    title: '暗夜追踪者',
    slug: 'night-tracker',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20horror%20manga%20cover%20with%20a%20mysterious%20figure%20in%20shadow%2C%20haunting%20eyes%20glowing%20in%20darkness%2C%20creepy%20atmosphere%2C%20abandoned%20building%20background%2C%20moonlight%2C%20eerie%20vibe%2C%20dark%20color%20palette%2C%20professional%20horror%20manga%20art%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    author: '鬼墨绘',
    category: 'horror',
    categories: ['horror', 'suspense'],
    status: '连载中',
    description: '城市中接连发生离奇失踪案件，所有线索都指向一个神秘的都市传说。记者林晓雨在调查过程中逐渐发现，这背后隐藏着一个令人不寒而栗的真相。黑暗中的追踪者，究竟是人还是鬼？',
    shortDescription: '城市离奇事件背后的恐怖真相追踪',
    rating: 9.1,
    ratingCount: 8900,
    views: 7620000,
    favorites: 456000,
    updateDate: '2026-08-02',
    latestChapter: '第98话 地下室',
    tags: ['恐怖', '悬疑', '都市传说', '惊悚', '调查'],
    featured: false,
    isHot: false,
    chapters: [
      { id: 98, title: '第98话 地下室', number: 98, updateDate: '2026-08-02', pageCount: 42 },
      { id: 97, title: '第97话 跟踪', number: 97, updateDate: '2026-07-26', pageCount: 45 },
      { id: 96, title: '第96话 第三个受害者', number: 96, updateDate: '2026-07-19', pageCount: 40 },
      { id: 95, title: '第95话 深夜来电', number: 95, updateDate: '2026-07-12', pageCount: 43 },
    ],
    reviews: [
      { id: 1, username: '深夜读者', avatar: '', rating: 5, content: '晚上看真的会让人毛骨悚然！氛围营造得太好了，画风也很对味。', date: '2026-08-03', likes: 678 },
      { id: 2, username: '恐怖爱好者', avatar: '', rating: 4, content: '悬疑感拉满，每期都留下新的悬念，让人欲罢不能。', date: '2026-08-02', likes: 432 },
    ],
  },
  {
    id: 8,
    title: '大唐风华录',
    slug: 'tang-dynasty-chronicles',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20manga%20style%20cover%20illustration%20of%20Tang%20Dynasty%20nobles%20in%20traditional%20hanfu%20clothing%2C%20ancient%20palace%20background%20with%20lanterns%2C%20elegant%20classical%20Chinese%20aesthetic%2C%20gold%20and%20vermilion%20color%20scheme%2C%20refined%20art%20style%20blending%20Chinese%20painting%20and%20manga&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    author: '墨染长安',
    category: 'historical',
    categories: ['historical', 'romance', 'fantasy'],
    status: '连载中',
    description: '大唐盛世，风华绝代。一位现代历史研究生意外穿越到唐朝，成为了长安城中一位小小史官。在那个辉煌的时代，她将亲历历史的波澜壮阔，遇见那些只在史书中出现的人物，书写一段跨越千年的传奇故事。',
    shortDescription: '穿越唐朝的历史传奇，亲历盛世风华',
    rating: 9.4,
    ratingCount: 12300,
    views: 8950000,
    favorites: 567000,
    updateDate: '2026-08-01',
    latestChapter: '第132话 玄武门',
    tags: ['历史', '穿越', '古风', '唐朝', '权谋'],
    featured: false,
    isHot: true,
    chapters: [
      { id: 132, title: '第132话 玄武门', number: 132, updateDate: '2026-08-01', pageCount: 48 },
      { id: 131, title: '第131话 朝堂风云', number: 131, updateDate: '2026-07-25', pageCount: 45 },
      { id: 130, title: '第130话 暗流涌动', number: 130, updateDate: '2026-07-18', pageCount: 42 },
      { id: 129, title: '第129话 诗会', number: 129, updateDate: '2026-07-11', pageCount: 46 },
      { id: 128, title: '第128话 长安夜宴', number: 128, updateDate: '2026-07-04', pageCount: 44 },
    ],
    reviews: [
      { id: 1, username: '历史控', avatar: '', rating: 5, content: '考据严谨，画风华丽，人物塑造有血有肉。大唐的风采被完美展现！', date: '2026-08-02', likes: 987 },
      { id: 2, username: '古风爱好者', avatar: '', rating: 5, content: '服装和场景都非常考究，剧情也引人入胜，期待后续发展！', date: '2026-08-01', likes: 765 },
    ],
  },
  {
    id: 9,
    title: '篮球少年',
    slug: 'basketball-boys',
    cover: 'https://readdy.ai/api/search-image?query=A%20sports%20manga%20cover%20illustration%20of%20a%20young%20basketball%20player%20jumping%20for%20a%20dunk%2C%20dynamic%20action%20shot%2C%20basketball%20court%20background%2C%20sweat%20and%20determination%2C%20vibrant%20sports%20energy%2C%20team%20spirit%20theme%2C%20professional%20sports%20manga%20art%20style%2C%20blue%20and%20orange%20color%20scheme&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    author: '跳跃工作室',
    category: 'sports',
    categories: ['sports', 'shounen', 'slice-of-life'],
    status: '连载中',
    description: '身高不足170cm的赵飞从小热爱篮球，但总被人说个子太矮打不了球。他不服输，凭借超快的速度和精准的投篮，一步步在校队中证明自己。这是关于梦想、汗水和热血青春的故事！',
    shortDescription: '矮个子少年的篮球梦想与热血青春物语',
    rating: 9.0,
    ratingCount: 10500,
    views: 7560000,
    favorites: 432000,
    updateDate: '2026-08-04',
    latestChapter: '第178话 全国大赛',
    tags: ['篮球', '运动', '青春', '热血', '校园'],
    featured: false,
    isHot: false,
    chapters: [
      { id: 178, title: '第178话 全国大赛', number: 178, updateDate: '2026-08-04', pageCount: 50 },
      { id: 177, title: '第177话 八强赛', number: 177, updateDate: '2026-07-28', pageCount: 48 },
      { id: 176, title: '第176话 新的战术', number: 176, updateDate: '2026-07-21', pageCount: 45 },
      { id: 175, title: '第175话 队长受伤', number: 175, updateDate: '2026-07-14', pageCount: 46 },
    ],
    reviews: [
      { id: 1, username: '篮球迷', avatar: '', rating: 5, content: '球场上的每一场比赛都让人热血沸腾！赵飞的成长让人感动。', date: '2026-08-04', likes: 567 },
      { id: 2, username: '运动少年', avatar: '', rating: 4, content: '比赛描绘很真实，节奏把控好，期待全国大赛的精彩对决！', date: '2026-08-03', likes: 432 },
    ],
  },
  {
    id: 10,
    title: '治愈小食堂',
    slug: 'healing-kitchen',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20slice%20of%20life%20manga%20cover%20of%20a%20cozy%20small%20restaurant%20kitchen%2C%20delicious%20food%20being%20prepared%2C%20warm%20steam%20rising%2C%20friendly%20chef%20character%2C%20soft%20warm%20lighting%2C%20comforting%20atmosphere%2C%20gentle%20pastel%20color%20palette%2C%20cozy%20Japanese%20iyashikei%20manga%20art%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    author: '暖食日记',
    category: 'slice-of-life',
    categories: ['slice-of-life', 'comedy'],
    status: '连载中',
    description: '在一座安静的小城里，有一家名为"暖心小厨"的餐厅。老板老陈用一道道温暖人心的家常菜，治愈着每一位来客的心。每一道菜背后，都藏着一个温暖的故事。',
    shortDescription: '温暖人心的家常美食与动人故事',
    rating: 9.3,
    ratingCount: 9800,
    views: 6890000,
    favorites: 398000,
    updateDate: '2026-08-02',
    latestChapter: '第89话 妈妈的饺子',
    tags: ['美食', '治愈', '日常', '温暖', '生活'],
    featured: false,
    isHot: false,
    chapters: [
      { id: 89, title: '第89话 妈妈的饺子', number: 89, updateDate: '2026-08-02', pageCount: 40 },
      { id: 88, title: '第88话 深夜拉面', number: 88, updateDate: '2026-07-26', pageCount: 42 },
      { id: 87, title: '第87话 夏日刨冰', number: 87, updateDate: '2026-07-19', pageCount: 38 },
      { id: 86, title: '第86话 外婆的红烧肉', number: 86, updateDate: '2026-07-12', pageCount: 44 },
    ],
    reviews: [
      { id: 1, username: '吃货一枚', avatar: '', rating: 5, content: '每次看完都想去吃饭！美食画得让人垂涎欲滴，故事也超暖心。', date: '2026-08-02', likes: 890 },
      { id: 2, username: '深夜看漫', avatar: '', rating: 5, content: '治愈系天花板！压力大的时候看看这个，整个人都放松下来了。', date: '2026-08-01', likes: 654 },
    ],
  },
  {
    id: 11,
    title: '暗影猎人',
    slug: 'shadow-hunter',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manga%20cover%20of%20a%20lone%20warrior%20with%20twin%20blades%20standing%20against%20monsters%2C%20gothic%20cityscape%20background%2C%20moonlight%2C%20dark%20fantasy%20theme%2C%20action%20pose%2C%20dramatic%20atmosphere%2C%20silver%20and%20dark%20color%20palette%2C%20professional%20dark%20fantasy%20manga%20art&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    author: '暗影工作室',
    category: 'fantasy',
    categories: ['fantasy', 'action', 'horror'],
    status: '连载中',
    rating: 9.1,
    ratingCount: 7600,
    views: 5780000,
    favorites: 312000,
    updateDate: '2026-08-03',
    latestChapter: '第67话 深渊',
    tags: ['暗黑', '奇幻', '猎魔', '动作'],
    featured: false,
    isHot: false,
    shortDescription: '黑夜中猎杀怪物的暗影猎手传奇',
    description: '在人类世界的阴影中，潜伏着来自异界的怪物。暗影猎手是守护人类世界的最后一道防线。年轻的猎手夜尘继承父亲的遗志，踏上了猎杀怪物、守护人类的道路。',
    chapters: [
      { id: 67, title: '第67话 深渊', number: 67, updateDate: '2026-08-03', pageCount: 44 },
      { id: 66, title: '第66话 猎手集结', number: 66, updateDate: '2026-07-27', pageCount: 46 },
      { id: 65, title: '第65话 古城遗迹', number: 65, updateDate: '2026-07-20', pageCount: 42 },
    ],
    reviews: [
      { id: 1, username: '暗影追随者', avatar: '', rating: 5, content: '画风太帅了！暗黑风格做得非常到位，打斗场景也很精彩。', date: '2026-08-02', likes: 456 },
    ],
  },
  {
    id: 12,
    title: '剑道少女',
    slug: 'kendo-girl',
    cover: 'https://readdy.ai/api/search-image?query=A%20sports%20manga%20cover%20of%20a%20female%20kendo%20practitioner%20in%20traditional%20armor%20holding%20bamboo%20sword%2C%20dojo%20background%2C%20determined%20expression%2C%20dynamic%20swing%20pose%2C%20traditional%20Japanese%20martial%20arts%20theme%2C%20clean%20composition%2C%20professional%20seinen%20manga%20art%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    author: '刀剑如梦',
    category: 'sports',
    categories: ['sports', 'slice-of-life', 'shounen'],
    status: '连载中',
    rating: 9.2,
    ratingCount: 8200,
    views: 6120000,
    favorites: 345000,
    updateDate: '2026-08-04',
    latestChapter: '第112话 决胜之剑',
    tags: ['剑道', '运动', '少女', '成长', '热血'],
    featured: false,
    isHot: true,
    shortDescription: '少女剑道选手的全国制霸之路',
    description: '高中一年级的柳叶从小跟随爷爷练习剑道，进入高中后加入了濒临废部的剑道社。她凭借出色的剑术和顽强的意志，带领剑道社一步步走向全国大赛的舞台。',
    chapters: [
      { id: 112, title: '第112话 决胜之剑', number: 112, updateDate: '2026-08-04', pageCount: 48 },
      { id: 111, title: '第111话 半决赛', number: 111, updateDate: '2026-07-28', pageCount: 45 },
      { id: 110, title: '第110话 宿敌', number: 110, updateDate: '2026-07-21', pageCount: 42 },
    ],
    reviews: [
      { id: 1, username: '剑道爱好者', avatar: '', rating: 5, content: '剑道动作描绘得非常专业！感受到作者对剑道的热爱。', date: '2026-08-04', likes: 345 },
    ],
  },
];

export const hotComics = allComics.filter(c => c.isHot);
export const featuredComics = allComics.filter(c => c.featured);
export const completedComics = allComics.filter(c => c.status === '已完结');